export default __webpack_public_path__ + "static/media/manage-screens.ce06079c.svg";